// OK 18/10/2024

import { Chantier } from "../interfaces";
import { ChantierFiles } from "../interfaces/chantierFiles.interface";
import { EmailRequest } from "../interfaces/emailRequest.interface";
import { Rendement } from "../interfaces/rendement.interface";
import { ObjectId } from "../types";
import { ip } from "../utils/setup";

const CHANTIER_API = `${ip}/api/Chantiers`;
const MAIL_API = `${ip}/api/Mail`;

// GET

export async function getRendements(): Promise<Rendement[]> {
    
    const response = await fetch(`${CHANTIER_API}/rendementByYear`, { credentials: "include" });
  if (response.ok) {
    const body: Rendement[] = await response.json();
    return body;
  } else {
    throw new Error("Erreur du serveur");
  }
}

export async function getDemAcc(_id: ObjectId): Promise<ChantierFiles> {
    const response = await fetch(`${CHANTIER_API}/${_id}/getFiles`, {
        credentials: "include"
    });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(
      "Erreur du serveur lors de la réception de la demande d'accès"
    );
  }
}

export async function getPpss(_id: ObjectId): Promise<ChantierFiles> {
    const response = await fetch(`${CHANTIER_API}/${_id}/getFiles`, {
        credentials: "include"
    });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error("Erreur du serveur lors de la réception du PPSS");
  }
}

export async function getChantiersNoHiden() {
  try {
      const response = await fetch(CHANTIER_API + "/noHiden",  {
          credentials: "include"
      });
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        `Connexion au serveur impossible, code serveur: ${response.status}`
      );
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

export async function getChantiersHiden() {
  try {
      const response = await fetch(CHANTIER_API + "/Hiden", {
          credentials: "include"
      });
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        `Connexion au serveur impossible, code serveur: ${response.status}`
      );
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

export async function getChantiers(): Promise<Chantier[]> {
  try {
      const response = await fetch(CHANTIER_API,  {
          credentials: "include"
      });
    if (response.ok) {
      const body: Chantier[] = await response.json();
      return body;
    } else {
      throw new Error("Erreur du serveur");
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

export async function getNomChantiers() {
  try {
      const response = await fetch(`${CHANTIER_API}/nomChant`, {
          credentials: "include"
      });
    if (response.ok) {
      return response.json();
    } else {
      if (response.status === 500) {
        throw new Error(
          `Connexion au serveur impossible, code serveur: ${response.status}`
        );
      } else if (response.status === 404) {
        throw new Error(
          `Chantier introuvable, assurez vous de posséder un chantier dans votre base de données, code serveur : ${response.status}`
        );
      } else {
        throw new Error(`Problème serveur, code serveur: ${response.status}`);
      }
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

// GET ID

export async function getChantier(_id: ObjectId): Promise<Chantier> {
    const response = await fetch(`${CHANTIER_API}/${_id}`, {
        credentials: "include"
    });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error("Erreur du serveur lors de la réception du chantier");
  }
}

// POST

export async function sendMail(emailRequest: EmailRequest) {
  try {
    await fetch(MAIL_API, {
      method: "POST",
        headers: { "Content-type": "application/json" },
        credentials: "include",
      body: JSON.stringify(emailRequest),
    });
  } catch (e: any) {
    throw new Error(e.message);
  }
}

export async function createChantier(
  newChantier: Partial<Chantier>
): Promise<Chantier> {
  const response = await fetch(CHANTIER_API, {
    method: "POST",
    headers: {
        "content-type": "application/json"
      },
      credentials: "include",
    body: JSON.stringify(newChantier),
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(" Erreur lors de la création du nouveau matériel");
  }
}

export async function sendMailForm(emailRequest: FormData) {
  const response = await fetch(MAIL_API + "/formEmail", {
    method: "POST",
      headers: {
          "content-type": "application/json"
      },
      credentials: "include",
    body: emailRequest,
  });
  if (response.ok) {
  } else {
    throw new Error(" Erreur lors de l' envoie du mail'");
  }
}

//PUT

export async function updateChantier(updateChantier: Chantier) {
  const { globalError, ...restChant } = updateChantier;
  const response = await fetch(`${CHANTIER_API}/${restChant.idChant}`, {
    method: "PUT",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    body: JSON.stringify(restChant),
  });
  if (response.ok) {
    return response.ok;
  } else {
    throw new Error("Erreur lors de l'édition du chantier");
  }
}

export async function createDemAcc(updateChantier: Partial<Chantier>) {
  try {
    await fetch(`${CHANTIER_API}/demAcc/${updateChantier.idChant}`, {
      method: "PUT",
        headers: { "Content-type": "application/json" },
        credentials: "include",
      body: JSON.stringify(updateChantier),
    });
  } catch (e: any) {
    throw new Error(e.message);
  }
}

export async function createPPSS(updateChantier: Partial<Chantier>) {
  try {
    await fetch(`${CHANTIER_API}/ppss/${updateChantier.idChant}`, {
      method: "PUT",
        headers: { "Content-type": "application/json" },
        credentials: "include",
      body: JSON.stringify(updateChantier),
    });
  } catch (e: any) {
    throw new Error(e.message);
  }
}

// DELETE

export async function archiveChantier(_id: ObjectId): Promise<ObjectId> {
  const response = await fetch(`${CHANTIER_API}/${_id}`, {
      method: "DELETE",
      credentials: "include"
  });
  if (response.ok) {
    return _id;
  } else {
    throw new Error("Erreur lors de l'archivage du chantier ");
  }
}
